import $ from 'jquery';
import StoreView from '../views/StoreView';
import Store from '../models/Store';
import svgPanZoom from 'svg-pan-zoom';
import { addStoreLabels } from '../map/store-labels';
import { addMap } from '../map/map';
import { addCurvedText } from '../map/curved-text';
import action from '../action';

function start(context){
  var params = Store.init(context);
  StoreView.render(params);
  bindEvents(params, context);
  setExpand(params);
}

function setExpand(res){
  if(res.storedata.exceptionalOpeningHours.length <3){
    $('#expand-timetables').hide();
    $('#timetables .line').show();
  }else{
    $('#expand-timetables').show();
    $('#timetables .line').hide();
  }
}

function bindEvents(params, context){

  const { mapType } = context.imdSettings;
  if (mapType.inhouse) {
    addMap('#svgmap', params.scimddata.imdFloors, params.mapStores, params.storeLocation.floorId, '', params.imddata.rotation);
    if($('#stores').html() != ''){
      addStoreLabels('#svgmap__container', '#stores > *', params.mapStores, params.imddata.rotation, params.scid);
    }

    setMap(params);
  }

  $('.phone-information__reveal').on('click', function() {
    $(this).closest('.phone-information').addClass('phone-information--full')
  });
  $('#backbutton').on('click', function(){
    Store.goBack();
  });
  $('.expand-container').on('click', function(){
    Store.toggleBlock(this.id);
  });
  $('.store-offer-wrapper').on('click', function(){
    Store.goToTips(this.id);
  });
  $('#storemap').on('click', function(){
    action.showStoreOnMap(params.id);
  });
  $('#map .nav-link').on('click', function(){
    action.showRouteToStore(params.id);
  });
}
function setMap(params){

  if($('#stores').html() != ''){

    if(!$.isEmptyObject(params.storeLocation) && typeof params.storeLocation.floorId != 'undefined'){

      var floorId = params.storeLocation.floorId;
      $.each(params.scimddata.imdFloors, function(i, floor){
        if(floor.floorId==floorId && typeof floor.map != 'undefined'){

          var panZoom = svgPanZoom('#svgmap', {
            center: false,
            fit: false,
            panEnabled: false
          });
          panZoom.center();
          panZoom.zoom(1);

          if(params.storeLocation.pinLocation){
            var x = params.storeLocation.pinLocation.x;
            var y = params.storeLocation.pinLocation.y;

            var customPan = getNewCoordinates({x: x, y: y}, params.imddata.rotation);
            var newCustomPan = {x: $('#svgmap').width()/2 - customPan.x, y: $('#svgmap').height()/2 - customPan.y};
            panZoom.pan(newCustomPan);

            if(typeof params.storeLocation.storeSpaceId != 'undefined'){

              $('#map').show();
              //Remove spaces from storeSpaceId
              var storeSpaceId = params.storeLocation.storeSpaceId.replace(/\s+/g, '');
              $('#storePath-'+storeSpaceId).addClass('selected');

              if($('#svgmap .selected')[0]){
                //Adust the zoom level depending on the size of the store space
                var storeSpaceWidth = $('#svgmap .selected')[0].getBBox().width;
                var storeSpaceHeight = $('#svgmap .selected')[0].getBBox().height;

                if(storeSpaceWidth > 300 || storeSpaceHeight > 300){
                  panZoom.zoom(1,5);
                }
                if(storeSpaceWidth < 100 && storeSpaceHeight < 100){
                  panZoom.zoom(2);
                }

              }else{
                console.log('hide map - could not find store space on map with given storeSpaceId '+params.storeLocation.storeSpaceId);
                $('#map').hide();
              }
            }else{
              console.log('hide map - storeSpaceId is undefined');
              $('#map').hide();
            }
          }else{
            console.log('hide map - could not found pinLocation, most likely this shop is located in an office tower');
            $('#map').hide();
          }
        }
      });
    }else{
      console.log('hide map - storelocation not found');
      $('#map').hide();
    }
  }else{
    console.log('hide map - map content missing');
    $('#map').hide();
  }

}

function getNewCoordinates(point, angle) {

  var radians = (Math.PI / 180) * angle,
      cos = Math.cos(radians),
      sin = Math.sin(radians),
      ny = point.y*cos + point.x*sin,
      nx = -point.y*sin + point.x*cos;


  return {x: nx, y: ny};
}

export default {
  start
};
